enum ElementEnum {
    WORK_ORDERS = 1000,
    MESSAGING = 1001,
    REPORTING = 1002,
    USERS = 1003,
    FORMS = 1004,
    MASTERS = 1005,
    JOURNAL_REGISTRY = 1006,
    DASHBOARD = 1007,
    ROUTES = 1009,
    WORKS = 1100,
};

export default ElementEnum;
